module.exports = "/dist/ljs/vars-5cf569a5d0be6d997879673aeebc302e.js";